export default __webpack_public_path__ + "693c527aec0de211945e97d9954976f7.ttf";